import * as types from './types'
import { AnyAction } from 'redux'
import moment from 'moment'
import { CountryCode } from '@carsys/enums/country-code'

export enum EModules {
  GMS = 'gms',
  PORTAL = 'portal'
}

export interface IStatsState {
  shopID: string
  companyUUID: string
  filteredByModule: string
  shopModules: any
  startDate: string
  endDate: string
  country: CountryCode | ''
}

// If we don't use a function to initialize the default state
// it becomes difficult to mock moment when testing.
const initializeDefaultState = (): IStatsState => ({
  shopID: '',
  companyUUID: '',
  filteredByModule: '',
  shopModules: {},
  country: '',
  startDate: moment().startOf('month').subtract(2, 'month').format('DD-MM-YYYY'),
  endDate: moment().endOf('month').format('DD-MM-YYYY')
})

const stats = (state: IStatsState = initializeDefaultState(), action: AnyAction) => {
  switch (action.type) {
    case types.SET_SHOP_ID:
      return { ...state, shopID: action.payload.shopID }
    case types.SET_COMPANY_UUID:
      return { ...state, companyUUID: action.payload.companyUUID }
    case types.SET_START_DATE:
      return { ...state, startDate: action.payload.startDate }
    case types.SET_END_DATE:
      return { ...state, endDate: action.payload.endDate }
    case types.SET_STATS_COUNTRY:
      return { ...state, country: action.payload.country }
    case types.SET_FILTERED_BY_MODULE:
      return {
        ...state,
        filteredByModule: action.payload.filteredByModule,
        shopModules: getShopModules(action.payload.filteredByModule)
      }
    default:
      return state
  }
}

const getShopModules = (filteredByModule: EModules): any => {
  switch (filteredByModule) {
    case EModules.GMS:
      return { module_gms_enabled: true }
    case EModules.PORTAL:
      return { module_gms_enabled: false, module_portal_enabled: true }
    default:
      return {}
  }
}

export default stats
